{
  "AGENT_MGMT": {
    "HEADER": "Aģenti",
    "HEADER_BTN_TXT": "Pievienot Aģentu",
    "LOADING": "Aģentu Saraksta Iegūšana",
    "DESCRIPTION": "Aģents ir jūsu klientu atbalsta komandas loceklis, kurš var skatīt lietotāja ziņojumus un atbildēt uz tiem. Tālāk esošajā sarakstā ir parādīti visi aģenti jūsu kontā.",
    "LEARN_MORE": "Uzzināt par lietotāju lomām",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrators",
      "AGENT": "Aģents"
    },
    "TABS": {
      "ACTIVE": "Aktīvs",
      "DEACTIVATED": "Deaktivizēts"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Atvienot Tālruni",
      "API": {
        "SUCCESS_MESSAGE": "Aģenta tālrunis veiksmīgi atvienots",
        "ERROR_MESSAGE": "Neizdevās atvienot aģenta tālruni, lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Reaktivizēt",
      "API": {
        "SUCCESS_MESSAGE": "Aģents veiksmīgi reaktivizēts",
        "ERROR_MESSAGE": "Neizdevās reaktivizēt aģentu, lūdzu, vēlāk mēģiniet vēlreiz"
      },
      "CONFIRM": {
        "TITLE": "Apstiprināt Reaktivizāciju",
        "MESSAGE": "Vai vēlaties reaktivizēt ",
        "YES": "Jā, Reaktivizēt ",
        "NO": "Nē, Atcelt "
      }
    },
    "LIST": {
      "404": "Šim kontam nav piesaistīts neviens aģents",
      "TITLE": "Pārvaldīt Jūsu komandas aģentus",
      "DESC": "Jūs varat pievienot/noņemt aģentus pie/no savas komandas.",
      "NAME": "Nosaukums",
      "EMAIL": "Epasts",
      "STATUS": "Statuss",
      "ACTIONS": "Darbības",
      "VERIFIED": "Pārbaudīts",
      "VERIFICATION_PENDING": "Tiek gaidīta verifikācija",
      "API_ALLOWED": "API piekļuve atļauta",
      "AVAILABLE_CUSTOM_ROLE": "Pieejamās pielāgotu lomu atļaujas"
    },
    "ADD": {
      "TITLE": "Pievienot aģentu Jūsu komandai",
      "DESC": "Jūs varat pievienot personas, kuras būs spējīgas apstrādāt iesūtnes un sniegt atbalstu.",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "FORM": {
        "NAME": {
          "LABEL": "Aģenta Vārds",
          "PLACEHOLDER": "Lūdzu, ievadiet aģenta vārdu"
        },
        "AGENT_TYPE": {
          "LABEL": "Loma",
          "PLACEHOLDER": "Lūdzu, izvēlieties lomu",
          "ERROR": "Nepieciešama loma"
        },
        "EMAIL": {
          "LABEL": "e-pasta Adrese",
          "PLACEHOLDER": "Lūdzu, ievadiet aģenta e-pasta adresi"
        },
        "SUBMIT": "Pievienot Aģentu"
      },
      "API": {
        "SUCCESS_MESSAGE": "Aģents ir veiksmīgi pievienots",
        "EXIST_MESSAGE": "Aģenta e-pasts jau tiek izmantots. Lūdzu, pamēģiniet citu e-pasta adresi",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "API": {
        "SUCCESS_MESSAGE": "Aģents ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai vēlaties izdzēst ",
        "DESCRIPTION": "Aģents tiks nekavējoties atslēgts, noņemts no visām komandām un iesūtnēm, un vairs nevarēs piekļūt šim kontam.",
        "YES": "Jā, Dzēst ",
        "NO": "Nē, Paturēt "
      }
    },
    "EDIT": {
      "TITLE": "Rediģēt aģentu",
      "FORM": {
        "NAME": {
          "LABEL": "Aģenta Vārds",
          "PLACEHOLDER": "Lūdzu, ievadiet aģenta vārdu"
        },
        "AGENT_TYPE": {
          "LABEL": "Loma",
          "PLACEHOLDER": "Lūdzu, izvēlieties lomu",
          "ERROR": "Nepieciešama loma"
        },
        "EMAIL": {
          "LABEL": "e-pasta Adrese",
          "PLACEHOLDER": "Lūdzu, ievadiet aģenta e-pasta adresi"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Pieejamība",
          "PLACEHOLDER": "Lūdzu, izvēlieties pieejamības statusu",
          "ERROR": "Nepieciešama pieejamība"
        },
        "API_ACCESS": {
          "LABEL": "Atļaut API piekļuvi",
          "HELP": "API piekļuve pēc noklusējuma ir atspējota. To ieslēdzot, tiek atļauts izmantot šī aģenta personīgo API atslēgu visos kontos, kuriem aģents pieder. Tas neietekmē pieteikšanos informācijas panelī."
        },
        "SUBMIT": "Rediģēt Aģentu"
      },
      "BUTTON_TEXT": "Rediģēt",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Aģents ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Atiestatīt Paroli",
        "ADMIN_SUCCESS_MESSAGE": "Aģentam tika nosūtīts e-pasta ziņojums ar paroles atiestatīšanas norādījumiem",
        "SUCCESS_MESSAGE": "Aģenta parole ir veiksmīgi atiestatīta",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Nav atrasts."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nav",
      "TITLE": {
        "AGENT": "Izvēlieties aģentu",
        "TEAM": "Izvēlieties komandu"
      },
      "LIST": {
        "NONE": "Nav"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Aģenti nav atrasti",
          "TEAM": "Komandas nav atrastas"
        },
        "PLACEHOLDER": {
          "AGENT": "Meklēt aģentus",
          "TEAM": "Meklēt komandas",
          "INPUT": "Meklēt aģentus"
        }
      }
    }
  }
}
